export const paidVersionURL = "https://www.ra9plus.jp/law"
